(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('CustomerType', CustomerType);

    CustomerType.$inject = ['$resource'];

    function CustomerType ($resource) {
        var resourceUrl =  'api/customer-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
